import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, iif } from 'rxjs';
import { BillingNumberRules } from '../../interfaces/billing-rules.interfaces';
import { EnvironmentConfig } from '../../interfaces/environment.interface';
import { AuthService } from '../auth/auth.service';
import { filter, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BillingRulesService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    private _auth: AuthService,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public find(): Observable<BillingNumberRules> {
    return this._http.get<BillingNumberRules>(
      `${this._baseUrl}/buyers/v2/billing-rules`
    );
  }

  public findByCompany(company: number): Observable<BillingNumberRules> {
    return this._http.get<BillingNumberRules>(
      `${this._baseUrl}/buyers/v2/billing-rules/${company}`
    );
  }

  public fetchRules(buyerCompanyId: number): Observable<BillingNumberRules> {
    const isServiceBuyerLoggedIn = this._auth.isLoggedInAsServiceBuyer();
    const companyRuleCriteria = {
      case: () => this._auth.userType === 'operator' && !isServiceBuyerLoggedIn,
      rules: () => this.findByCompany(buyerCompanyId),
      enabled: () =>
        !!this._auth.allBuyerConfigs.enableBillingNumberRules.includes(
          buyerCompanyId
        ),
    };

    const buyerRuleCriteria = {
      case: () => this._auth.userType !== 'operator' || isServiceBuyerLoggedIn,
      rules: () => this.find(),
      enabled: () => !!this._auth.buyerConfig?.enableBillingNumberRules,
    };

    return iif(
      () => companyRuleCriteria.case(),
      companyRuleCriteria.rules().pipe(filter(companyRuleCriteria.enabled)),
      buyerRuleCriteria.rules().pipe(filter(buyerRuleCriteria.enabled))
    ).pipe(shareReplay());
  }
}
